module.exports = __webpack_public_path__ + "static/media/img_52.e803d7b1.png";